import { render, staticRenderFns } from "./campaign-list.vue?vue&type=template&id=6c71bfcd&"
import script from "./campaign-list.vue?vue&type=script&lang=js&"
export * from "./campaign-list.vue?vue&type=script&lang=js&"
import style0 from "./campaign-list.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports